export default "__VITE_ASSET__6OvkTiHU__"